import { styled } from '@mui/material/styles';

const CardGuide = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const HeaderCard = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  margin-bottom: 8px;
`;

export { CardGuide, HeaderCard };
